import { duration } from "moment";
import { t } from "i18next";
import { Modality, ModalityType } from "../constants/options";
import {
  ComplaintsSymptomsIcon,
  MaskIcon,
  AllergenIcon,
  MedicineIcon,
  DiagnosisIcon,
  AttachmentIcon,
  GridIcon,
  FlowerIcon,
  FlowerReversedIcon,
  NeedleIcon,
  PrescriptionIcon,
  DryNeedlingIcon,
  CuppingIcon,
  BeautyIcon,
  CosmeticMedicineIcon,
} from "../images/prescription/svg-components";
import { GetLocalStorage } from "./cryptography";
import { QR_CODE_TOKEN } from "../constants/storage-keys";
import { IsEmptyStr } from "./field-validation";
import { v4 as uuidv4 } from 'uuid';
import moment from "moment";

export enum Section {
  COMPLAINTS,
  PAST_DISEASE,
  FAMILY_DISEASE,
  ALLERGY,
  PERSONAL_OTHER,
  EXAMINATION,
  ATTACHMENT,
  OTHER,
  REMARKS,
  FULL,
  DIAGNOSIS,
  RESULT,
  ACUPUNCTURE,
}

// export const MEDICAL_HISTORY_SECTION = [
//   {
//     id: Section.COMPLAINTS,
//     label: "COMPLAINTS_SYMPTOMS",
//     icon: ComplaintsSymptomsIcon,

//   },
//   { id: Section.PAST_DISEASE, label: "PAST_DISEASE", icon: MaskIcon },
//   { id: Section.FAMILY_DISEASE, label: 'FAMILY_DISEASE_HISTORY', icon: MaskIcon, options: [] },
//   { id: Section.ALLERGY, label: "ALLERGEN", icon: AllergenIcon },
//   {
//     id: Section.PERSONAL_OTHER,
//     label: "PERSONAL_OTHER",
//     icon: MedicineIcon,
//   },
//   {
//     id: Section.EXAMINATION,
//     label: "EXAMINATION",
//     icon: DiagnosisIcon,
//   },
//   {
//     id: Section.ATTACHMENT,
//     label: "ATTACHMENT",
//     icon: AttachmentIcon,
//   },
//   { id: Section.REMARKS, label: "REMARKS", icon: GridIcon},
// ];

export const MEDICAL_HISTORY_SECTION = [
  {
    id: Section.COMPLAINTS,
    label: "COMPLAINTS_SYMPTOMS",
    icon: ComplaintsSymptomsIcon,
  },
  { id: Section.PAST_DISEASE, label: "PAST_DISEASE", icon: MaskIcon },
  { id: Section.PERSONAL_OTHER, label: "PERSONAL_OTHER", icon: MedicineIcon },
  { id: Section.EXAMINATION, label: "EXAMINATION", icon: DiagnosisIcon },
  {
    id: Section.ATTACHMENT,
    label: "ASSISTANT_EXAMINATION",
    icon: AttachmentIcon,
  },
  { id: Section.RESULT, label: "RESULT_PREVIEW", icon: ComplaintsSymptomsIcon },
  // { id: Section.DIAGNOSIS, label: "DIAGNOSIS", icon: DiagnosisIcon, },
];
export const MEDICAL_HISTORY_SECTION_FOR_SUMMARY = [
  {
    id: Section.COMPLAINTS,
    label: "COMPLAINTS_SYMPTOMS",
    icon: ComplaintsSymptomsIcon,
  },
  { id: Section.PAST_DISEASE, label: "PAST_DISEASE", icon: MaskIcon },
  { id: Section.PERSONAL_OTHER, label: "PERSONAL_OTHER", icon: MedicineIcon },
  { id: Section.EXAMINATION, label: "EXAMINATION", icon: DiagnosisIcon },
  {
    id: Section.ATTACHMENT,
    label: "ASSISTANT_EXAMINATION",
    icon: AttachmentIcon,
  },
  { id: Section.FULL, label: "FULL", icon: GridIcon },
  { id: Section.DIAGNOSIS, label: "DIAGNOSIS", icon: DiagnosisIcon },
  { id: Section.ACUPUNCTURE, label: "ACUPUNCTURE_MASSAGE_MEDICINE_MODE", icon: NeedleIcon },

];
// `title` is a getter so it re-evaluates `t()` on each read. Previously these
// were eager `t(...)` calls captured at module-load time, which froze the
// translation to whatever language i18next had resolved before this module
// was first imported — causing the dropdown to occasionally show the wrong
// language depending on module load order vs. i18n/LanguageDetector init.
export const MODALITY_OPTIONS = [
  {
    get title() { return t("MEDICINE"); },
    get name() { return t("MEDICINE"); },
    get label() { return t("MEDICINE"); },
    id: Modality.CHINESE_MEDICINE,
    icon: PrescriptionIcon,
    desc: "PRESCRIBE_MEDICATION_TO_THE_PATIENT",
    plainTitle: "MEDICINE",
    shortTitle: "TCM",
    type: ModalityType.TCM,
    seqNo: 1,
  },
  {
    get title() { return t("ACUPUNCTURE"); },
    get name() { return t("ACUPUNCTURE"); },
    get label() { return t("ACUPUNCTURE"); },
    id: Modality.ACUPUNCTURE,
    icon: NeedleIcon,
    desc: "PRESCRIBE_ACUPUNCTURE_TO_THE_PATIENT",
    plainTitle: "ACUPUNCTURE",
    shortTitle: "ACU",
    type: ModalityType.MASSAGE,
    seqNo: 2,
  },
  {
    get title() { return t("MASSAGE"); },
    get name() { return t("MASSAGE"); },
    get label() { return t("MASSAGE"); },
    id: Modality.MASSAGE,
    icon: FlowerIcon,
    desc: "PRESCRIBE_MASSAGE_TO_THE_PATIENT",
    plainTitle: "MASSAGE",
    shortTitle: "MAS",
    type: ModalityType.MASSAGE,
    seqNo: 3,
  },
  {
    get title() { return t("REMEDIAL_MASSAGE_OPTION"); },
    get name() { return t("REMEDIAL_MASSAGE"); },
    get label() { return t("REMEDIAL_MASSAGE"); },
    id: Modality.REMEDIAL_MASSAGE,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_REMEDIAL_MASSAGE_TO_THE_PATIENT",
    plainTitle: "REMEDIAL_MASSAGE",
    shortTitle: "RMAS",
    type: ModalityType.MASSAGE,
    seqNo: 4,
  },
  {
    get title() { return t("CUPPING"); },
    get name() { return t("CUPPING"); },
    get label() { return t("CUPPING"); },
    id: Modality.CUPPING,
    icon: CuppingIcon,
    desc: "PRESCRIBE_CUPPING_TO_THE_PATIENT",
    plainTitle: "CUPPING",
    shortTitle: "CUP",
    type: ModalityType.MASSAGE,
    seqNo: 5,
  },
  {
    get title() { return t("DRY_NEEDLING"); },
    get name() { return t("DRY_NEEDLING"); },
    get label() { return t("DRY_NEEDLING"); },
    id: Modality.DRY_NEEDLING,
    icon: DryNeedlingIcon,
    desc: "PRESCRIBE_DRY_NEEDLING_TO_THE_PATIENT",
    plainTitle: "DRY_NEEDLING",
    shortTitle: "DN",
    type: ModalityType.MASSAGE,
    seqNo: 6,
  },
  {
    get title() { return t("DEEP_TISSUE_MASSAGE"); },
    get name() { return t("DEEP_TISSUE_MASSAGE"); },
    get label() { return t("DEEP_TISSUE_MASSAGE"); },
    id: Modality.DEEP_TISSUE_MASSAGE,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_DEEP_TISSUE_MASSAGE_TO_THE_PATIENT",
    plainTitle: "DEEP_TISSUE_MASSAGE",
    shortTitle: "DTM",
    type: ModalityType.MASSAGE,
    seqNo: 7,
  },
  {
    get title() { return t("SPORTS_MASSAGE"); },
    get name() { return t("SPORTS_MASSAGE"); },
    get label() { return t("SPORTS_MASSAGE"); },
    id: Modality.SPORTS_MASSAGE,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_SPORTS_MASSAGE_TO_THE_PATIENT",
    plainTitle: "SPORTS_MASSAGE",
    shortTitle: "SPM",
    type: ModalityType.MASSAGE,
    seqNo: 8,
  },
  {
    get title() { return t("PREGNANCY_MASSAGE"); },
    get name() { return t("PREGNANCY_MASSAGE"); },
    get label() { return t("PREGNANCY_MASSAGE"); },
    id: Modality.PREGNANCY_MASSAGE,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_PREGNANCY_MASSAGE_TO_THE_PATIENT",
    plainTitle: "PREGNANCY_MASSAGE",
    shortTitle: "PM",
    type: ModalityType.MASSAGE,
    seqNo: 9,
  },
  {
    get title() { return t("MYOTHERAPY"); },
    get name() { return t("MYOTHERAPY"); },
    get label() { return t("MYOTHERAPY"); },
    id: Modality.MYOTHERAPY,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_MYOTHERAPY_TO_THE_PATIENT",
    plainTitle: "MYOTHERAPY",
    shortTitle: "MYO",
    type: ModalityType.MASSAGE,
    seqNo: 10,
  },
  {
    get title() { return t("ASSISTED_STRETCHING"); },
    get name() { return t("ASSISTED_STRETCHING"); },
    get label() { return t("ASSISTED_STRETCHING"); },
    id: Modality.ASSISTED_STRETCHING,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_ASSISTED_STRETCHING_TO_THE_PATIENT",
    plainTitle: "ASSISTED_STRETCHING",
    shortTitle: "ASSG",
    type: ModalityType.MASSAGE,
    seqNo: 11,
  },
  {
    get title() { return t("TRIGGER_PT_THERAPY"); },
    get name() { return t("TRIGGER_PT_THERAPY"); },
    get label() { return t("TRIGGER_PT_THERAPY"); },
    id: Modality.TRIGGER_PT_THERAPY,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_TRIGGER_PT_THERAPY_TO_THE_PATIENT",
    plainTitle: "TRIGGER_PT_THERAPY",
    shortTitle: "TPT",
    type: ModalityType.MASSAGE,
    seqNo: 12,
  },
  {
    get title() { return t("MYOFASCIAL_RELEASE"); },
    get name() { return t("MYOFASCIAL_RELEASE"); },
    get label() { return t("MYOFASCIAL_RELEASE"); },
    id: Modality.MYOFASCIAL_RELEASE,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_MYOFASCIAL_RELEASE_TO_THE_PATIENT",
    plainTitle: "MYOFASCIAL_RELEASE",
    shortTitle: "MFR",
    type: ModalityType.MASSAGE,
    seqNo: 13,
  },
  {
    get title() { return t("JOINT_MOBILISATION"); },
    get name() { return t("JOINT_MOBILISATION"); },
    get label() { return t("JOINT_MOBILISATION"); },
    id: Modality.JOINT_MOBILISATION,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_JOINT_MOBILISATION_TO_THE_PATIENT",
    plainTitle: "JOINT_MOBILISATION",
    shortTitle: "JM",
    type: ModalityType.MASSAGE,
    seqNo: 14,
  },
  {
    get title() { return t("PHYSIO"); },
    get name() { return t("PHYSIO"); },
    get label() { return t("PHYSIO"); },
    id: Modality.PHYSIO,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_PHYSIO_TO_THE_PATIENT",
    plainTitle: "PHYSIO",
    shortTitle: "PHY",
    type: ModalityType.MASSAGE,
    seqNo: 15,
  },
  {
    get title() { return t("CHIRO"); },
    get name() { return t("CHIRO"); },
    get label() { return t("CHIRO"); },
    id: Modality.CHIRO,
    icon: FlowerReversedIcon,
    desc: "PRESCRIBE_CHIRO_TO_THE_PATIENT",
    plainTitle: "CHIRO",
    shortTitle: "CHI",
    type: ModalityType.MASSAGE,
    seqNo: 16,
  },
  {
    get title() { return t("BEAUTY"); },
    get name() { return t("BEAUTY"); },
    get label() { return t("BEAUTY"); },
    id: Modality.BEAUTY,
    icon: BeautyIcon,
    desc: "PRESCRIBE_BEAUTY_TO_THE_PATIENT",
    plainTitle: "BEAUTY",
    shortTitle: "BEA",
    type: ModalityType.OTHER,
    seqNo: 17,
  },
  {
    get title() { return t("COSMETIC_MEDICINE"); },
    get name() { return t("COSMETIC_MEDICINE"); },
    get label() { return t("COSMETIC_MEDICINE"); },
    id: Modality.COSMETIC_MEDICINE,
    icon: CosmeticMedicineIcon,
    desc: "PRESCRIBE_COSMETIC_MEDICINE_TO_THE_PATIENT",
    plainTitle: "COSMETIC_MEDICINE",
    shortTitle: "CM",
    type: ModalityType.OTHER,
    seqNo: 18,
  },
];

export const GetHistoryContentBySection = (section: any) => {
  switch (section) {
    case Section.COMPLAINTS:
      return "complaintMain";
    case Section.EXAMINATION:
      return "examinationMain";
    // case Section.FAMILY_DISEASE: return "familyDiseaseHistory";
    case Section.PAST_DISEASE:
      return "previousHistoryMain";
    case Section.ALLERGY:
      return "allergen";
    case Section.PERSONAL_OTHER:
      return "personalHealthMain";
    case Section.ATTACHMENT:
      return "auxiliaryTestMain";
    case Section.FULL:
      return "summaryMain";
    case Section.DIAGNOSIS:
      return "evaluationMain";
    case Section.OTHER:
      return "others";
    default:
      return "summaryMain";
  }
};
export const GetResultBySection = (section: any, obj: any) => {
  const appendDesc = (prefixName: string, desc: string) => {
    return `${!IsEmptyStr(desc) ? `${prefixName}: ${desc}` : ""}`;
  }

  switch (section) {
    case Section.COMPLAINTS:
      let result = {
        en: IsEmptyStr(obj.complaintMain.en.complaintResult) ? appendDesc("Symptom Description", obj.complaintMain.en.complaintPreviousTreatment)
          : obj.complaintMain.en.complaintResult,
        cn: IsEmptyStr(obj.complaintMain.cn.complaintResult) ? appendDesc("症状描述", obj.complaintMain.cn.complaintPreviousTreatment)
          : obj.complaintMain.cn.complaintResult,
      };
      return result;
    case Section.EXAMINATION:
      return {
        en: IsEmptyStr(obj.examinationMain.en.examinationResult) ? appendDesc("Description", obj.examinationMain.en.examinationOther)
          : obj.examinationMain.en.examinationResult,
        cn: IsEmptyStr(obj.examinationMain.cn.examinationResult) ? appendDesc("描述", obj.examinationMain.cn.examinationOther)
          : obj.examinationMain.cn.examinationResult,
      };
    // case Section.FAMILY_DISEASE: return "familyDiseaseHistory";
    case Section.PAST_DISEASE:
      return {
        en: obj.previousHistoryMain.en.previousHistoryResult,
        cn: obj.previousHistoryMain.cn.previousHistoryResult,
      };
    case Section.PERSONAL_OTHER:
      return {
        en: obj.personalHealthMain.en.personalHealthResult,
        cn: obj.personalHealthMain.cn.personalHealthResult,
      };
    case Section.ATTACHMENT:
      return {
        en: obj.auxiliaryTestMain.en.auxiliaryTestResult,
        cn: obj.auxiliaryTestMain.cn.auxiliaryTestResult,
      };
    case Section.FULL:
      return {
        en: obj.summaryMain.en.summaryResult,
        cn: obj.summaryMain.cn.summaryResult,
      };
    case Section.DIAGNOSIS:
      return {
        en: IsEmptyStr(obj.evaluationMain.en.evaluationResult) ? appendDesc("Description", obj.evaluationMain.en.evaluationOther)
          : obj.evaluationMain.en.evaluationResult,
        cn: IsEmptyStr(obj.evaluationMain.cn.evaluationResult) ? appendDesc("描述", obj.evaluationMain.cn.evaluationOther)
          : obj.evaluationMain.cn.evaluationResult,
      };
    case Section.ACUPUNCTURE:
      return {
        en: IsEmptyStr(obj.painInfoMain.en.imagePointResult) ? appendDesc("Description", obj.painInfoMain.en.imagePointOther)
          : obj.painInfoMain.en.imagePointResult,
        cn: IsEmptyStr(obj.painInfoMain.cn.imagePointResult) ? appendDesc("描述", obj.painInfoMain.cn.imagePointOther)
          : obj.painInfoMain.cn.imagePointResult,
      };
  }
};

export enum Step {
  SYMPTOMS = "SYMPTOMS",
  DIAGNOSIS = "DIAGNOSIS",
  TREATMENT_INTRO = "TREATMENT_INTRO",
  TREATMENT = "TREATMENT",
  PAYMENT = "PAYMENT",
  FINISH = "FINISH",
}

export interface Treatment {
  name: string;
  id: number;
  treatmentCategoryId: Modality;
  uuid: string;
  index: number;
  seqNo: number;
  price?: string | number;
}
export const IsSameTreatment = (
  treatment1: Treatment | any,
  treatment2: Treatment | any
) => {
  //   return Boolean(treatment1?.uuid == treatment2?.uuid);
  return treatment1?.id == treatment2?.id;
};
export const GetTotalGrans = (day: number, grans: number) => {
  return ((day ?? 0) * (grans ?? 0)).toFixed(1);
};
/**
 * Number of days the herb dosages are spread over. Herb raw/gran values are
 * stored as the total across all days, so the daily amount is total / days.
 */
export const GetDosageDays = (treatment: any) => {
  const value = Number(
    treatment?.instruction?.noOfRepeats ?? treatment?.days ?? 1
  );
  return Number.isFinite(value) && value > 0 ? value : 1;
};
export const GetDailyDosage = (total: any, days: number) => {
  const parsed = Number(total ?? 0);
  if (!Number.isFinite(parsed) || !Number.isFinite(days) || days <= 0)
    return "0.0";
  return (parsed / days).toFixed(1);
};
/**
 * Herb Section
 */
export enum HerbType {
  PREMIUM = 1,
  STANDARD = 2,
}
export enum DosageType {
  RAW_HERBS = 1,
  HERBS_EXTRACT = 2,
  HERBAL_MEDICATION = 3,
  EXTERNAL = 4,
}
export const DOSAGE_TYPE: any[] = [
  { id: DosageType.RAW_HERBS, label: t("RAW_HERBS") },
  { id: DosageType.HERBS_EXTRACT, label: t("HERBS_EXTRACT") },
  { id: DosageType.HERBAL_MEDICATION, label: t("HERBAL_MEDICATION") },
  { id: DosageType.EXTERNAL, label: t("EXTERNAL") },
];
export interface MedicineModel {
  treatment?: Treatment;
  selectedItems: any[];
  noOfRepeats: string | number;
  toBeDispensedAfter: string | number;
  dosageType: DosageType;
  isSecondBoilRequired: boolean;
  boils: HerbBoils[];
  totalCost: number;
}
export interface HerbBoils {
  noCupWater: string;
  boilTime: string;
  noCupsRemains: string;
}
export const EmptyMedicineModel: MedicineModel = {
  selectedItems: [],
  noOfRepeats: "",
  toBeDispensedAfter: "",
  dosageType: DosageType.RAW_HERBS,
  isSecondBoilRequired: false,
  boils: [
    { noCupWater: "", boilTime: "", noCupsRemains: "" },
    { noCupWater: "", boilTime: "", noCupsRemains: "" },
  ],
  totalCost: 0,
};

export interface MassageModel {
  treatment?: Treatment;
  selectedItems: any[];
  feeSchedule?: number;
  duration: string;
  precaution: string;
  totalCost: number;
}
export const EmptyMassageModel: MassageModel = {
  selectedItems: [],
  feeSchedule: 0,
  duration: "",
  precaution: "",
  totalCost: 0,
};

export interface PaymentModel {
  otherFees: OtherFees[];
}
export interface OtherFees {
  id: string;
  name: string;
  amount: string | number;
  isGstApplicable: boolean;
}
/**
 * Payment
 */

export enum PaymentType {
  CASH = "CASH",
  CARD_ONLINE = "CARD_ONLINE",
  CARD_OFFLINE = "CARD_OFFLINE",
  HICAPS = "HICAPS",
}
export enum PaymentStatus {
  PAID = "P",
  NOT_PAID = "NP",
  FAILED = "F",
}
export interface PaymentRetryLog {
  historyId: number;
  lastTryDate: string;
  retryCount: number;
}

export const DIAGNOSIS_FEE_NAME = "__DIAGNOSIS_FEE__";
export const DISCOUNT_FEE_NAME = "__DISCOUNT_FEE__";
export const SURCHARGE_AMOUNT = 3;
export const RAW_GRAN_RATIO = 5;

/**
 * Time Unit
 */

export enum TimeUnit {
  SECOND = 1,
  MINUTE = 2,
  HOUR = 3,
  DAY = 4,
  WEEK = 5,
  MONTH = 6,
  YEAR = 7,
}

export const TimeUnitOptions = [
  { id: TimeUnit.SECOND, nameCn: "秒", nameEn: "Second", nameTh: "วินาที", nameVn: "Giây" },
  { id: TimeUnit.MINUTE, nameCn: "分钟", nameEn: "Minute", nameTh: "นาที", nameVn: "Phút" },
  { id: TimeUnit.HOUR, nameCn: "小时", nameEn: "Hour", nameTh: "ชั่วโมง", nameVn: "Giờ" },
  { id: TimeUnit.DAY, nameCn: "天", nameEn: "Day", nameTh: "วัน", nameVn: "Ngày" },
  { id: TimeUnit.WEEK, nameCn: "周", nameEn: "Week", nameTh: "สัปดาห์", nameVn: "Tuần" },
  { id: TimeUnit.MONTH, nameCn: "月", nameEn: "Month", nameTh: "เดือน", nameVn: "Tháng" },
  { id: TimeUnit.YEAR, nameCn: "年", nameEn: "Year", nameTh: "ปี", nameVn: "Năm" },
];

/**
 * Frequency Unit
 */

export enum FrequencyUnit {
  SUDDEN_ONSET = 1,
  INTERMITTENT = 2,
  PERSISTENT = 3,
  RECURRENT = 4,
  ALWAYS = 5,
  OFTEN = 6,
  OCCASIONALLY = 7,
  IRREGULAR = 8,
  UNSTABLE = 9,
  RECURRENT_ATTACK = 10,
}

export const FrequencyUnitOptions = [
  { id: FrequencyUnit.SUDDEN_ONSET, nameCn: "突发", nameEn: "sudden onset", nameTh: "เริ่มเฉียบพลัน", nameVn: "Khởi phát đột ngột" },
  { id: FrequencyUnit.INTERMITTENT, nameCn: "间断", nameEn: "intermittent", nameTh: "เป็น ๆ หาย ๆ", nameVn: "Gián đoạn" },
  { id: FrequencyUnit.PERSISTENT, nameCn: "持续", nameEn: "persistent", nameTh: "ต่อเนื่อง", nameVn: "Liên tục" },
  { id: FrequencyUnit.RECURRENT, nameCn: "反复", nameEn: "recurrent", nameTh: "เกิดซ้ำ", nameVn: "Tái phát" },
  { id: FrequencyUnit.ALWAYS, nameCn: "一直", nameEn: "always", nameTh: "ตลอดเวลา", nameVn: "Luôn luôn" },
  { id: FrequencyUnit.OFTEN, nameCn: "经常", nameEn: "often", nameTh: "บ่อยครั้ง", nameVn: "Thường xuyên" },
  {
    id: FrequencyUnit.OCCASIONALLY,
    nameCn: "偶发",
    nameEn: "happen occasionally",
    nameTh: "นาน ๆ ครั้ง",
    nameVn: "Thỉnh thoảng",
  },
  { id: FrequencyUnit.IRREGULAR, nameCn: "不规律的", nameEn: "irregular", nameTh: "ไม่สม่ำเสมอ", nameVn: "Không đều đặn" },
  { id: FrequencyUnit.UNSTABLE, nameCn: "不稳定的", nameEn: "unsteady", nameTh: "ไม่คงที่", nameVn: "Không ổn định" },
  {
    id: FrequencyUnit.RECURRENT_ATTACK,
    nameCn: "反复发作",
    nameEn: "recurrent attack",
    nameTh: "กำเริบซ้ำ",
    nameVn: "Tái phát từng đợt",
  },
];

/**
 * Symptom Type
 */

export enum SymptomType {
  MAIN = 1,
  ASSOCIATION = 2,
}

export enum SymptomTimeType {
  OCCURRENCE = 1,
  RECURRENCE = 2,
  AGGRAVATION = 3,
}

export const SymptomTimeTypeOptions = [
  { id: SymptomTimeType.OCCURRENCE, nameCn: "出现时间", nameEn: "Occurrence", nameTh: "เวลาที่เริ่มมีอาการ", nameVn: "Thời gian khởi phát" },
  { id: SymptomTimeType.RECURRENCE, nameCn: "反复时间", nameEn: "Recurrence", nameTh: "เวลาที่อาการกลับมาเป็นซ้ำ", nameVn: "Thời gian tái phát" },
  {
    id: SymptomTimeType.AGGRAVATION,
    nameCn: "加重时间",
    nameEn: "Aggregation",
    nameTh: "เวลาที่อาการกำเริบ",
    nameVn: "Thời gian nặng lên",
  },
];
interface SymptomTime {
  duration: number;
  unit: number; //TimeUnitOptions
  type: SymptomTimeType;
}
type Symptom = { id: number; nameCn: string; nameEn: string; nameTh?: string; nameVn?: string };

interface SymptomTime {
  duration: number;
  unit: number; // TimeUnitOptions id
  type: SymptomTimeType;
}

const byId = <T extends { id: number }>(arr: T[], id?: number) =>
  arr.find((x) => x.id === id);

/** 英文单位复数 */
const enUnit = (unitId: number, n: number) => {
  const u = byId(TimeUnitOptions, unitId)?.nameEn ?? "";
  if (!u) return "";
  return n === 1 ? u.toLowerCase() : (u + "s").toLowerCase();
};

/** 连接症状名：英文用 ", … and …"，中文用 "、…和…" */
const joinNames = (list: string[], lang: "en" | "cn") => {
  const arr = list.filter(Boolean);
  if (arr.length === 0) return "";
  if (arr.length === 1) return arr[0];

  if (lang === "en") {
    return arr.slice(0, -1).join(", ") + " and " + arr[arr.length - 1];
  }
  // zh
  return arr.slice(0, -1).join("、") + "和" + arr[arr.length - 1];
};

/** 时间子句 */
const timeClause = (t: SymptomTime, lang: "en" | "cn") => {
  const { duration, unit, type } = t;
  if (!duration || !unit) return "";

  if (lang === "en") {
    const unitStr = enUnit(unit, duration);
    const verb =
      type === SymptomTimeType.OCCURRENCE
        ? "occur"
        : type === SymptomTimeType.RECURRENCE
          ? "recur"
          : "worsen"; // AGGRAVATION
    return `${verb} every ${duration} ${unitStr}`;
  } else {
    const unitStr = byId(TimeUnitOptions, unit)?.nameCn ?? "";
    const tail =
      type === SymptomTimeType.OCCURRENCE
        ? "出现"
        : type === SymptomTimeType.RECURRENCE
          ? "反复"
          : "加重";
    return `每${duration}${unitStr}${tail}`;
  }
};

/** 清理空格与多余标点 */
const tidy = (s: string) =>
  s
    .replace(/\s+/g, " ")
    .replace(/\s+([,.!?;:])/g, "$1")
    .replace(/\s+—\s+/g, " — ")
    .trim();

/** 主函数 */
const GetSymptomPreview = (
  symptoms: Symptom[] = [],
  times: SymptomTime[] = [],
  otherStrCn: string = "",
  otherStrEn: string = "",
  frequencyId?: number // FrequencyUnitOptions id
) => {
  // 症状
  const symptomEn = joinNames(
    symptoms.map((s) => s?.nameEn).filter(Boolean),
    "en"
  );
  const symptomCn = joinNames(
    symptoms.map((s) => s?.nameCn).filter(Boolean),
    "cn"
  );

  // 频率
  const freqEn = byId(FrequencyUnitOptions, frequencyId)?.nameEn ?? "";
  const freqCn = byId(FrequencyUnitOptions, frequencyId)?.nameCn ?? "";

  // 时间子句
  const timeEnClauses = (times || [])
    .map((t) => timeClause(t, "en"))
    .filter(Boolean);
  const timeCnClauses = (times || [])
    .map((t) => timeClause(t, "cn"))
    .filter(Boolean);

  // 组合（英文：Symptoms — frequency, time1; time2. other）
  const partsEn: string[] = [];
  if (symptomEn) partsEn.push(symptomEn);
  const afterDashEn: string[] = [];
  if (freqEn) afterDashEn.push(freqEn);
  if (timeEnClauses.length) afterDashEn.push(timeEnClauses.join("; "));
  if (afterDashEn.length) partsEn.push("— " + afterDashEn.join(", "));
  let previewEn = partsEn.join(" ") + (partsEn.length ? "." : "");
  if (otherStrEn) previewEn += " " + otherStrEn;

  // 组合（中文：症状——频率，时间；时间。other）
  const partsCn: string[] = [];
  if (symptomCn) partsCn.push(symptomCn);
  const afterDashCn: string[] = [];
  if (freqCn) afterDashCn.push(freqCn);
  if (timeCnClauses.length) afterDashCn.push(timeCnClauses.join("；"));
  if (afterDashCn.length) partsCn.push("——" + afterDashCn.join("，"));
  let previewCn = partsCn.join("") + (partsCn.length ? "。" : "");
  if (otherStrCn) previewCn += otherStrCn;

  return {
    en: tidy(previewEn),
    cn: tidy(previewCn),
  };
};

export type PrescriptionSectionHandle = {
  update: (isWarning: boolean) => Promise<any>;
};

export const LABEL_WIDTH = " w-36 ";
export const LABEL_WIDTH_STYLE = "9rem";

export const GetEmptyFeeInfo = (name: string, amount: string = "") => {
  return { name, amount, id: uuidv4(), isGstApplicable: true };
}

export const CalculateIncludedGst = (amount: number | string | null | undefined) => {
  const numericAmount = Number(amount) || 0;
  return numericAmount / 11;
}

export const IsRecordBehalfOfOthers = (isOwner: boolean, history: any) => {
  return isOwner && history?.createdBy !== history?.createdByUserId;
}

export enum WorkflowType {
  TCM_INCLUDED = "TCM_INCLUDED",
  TCM_EXCLUDED = "TCM_EXCLUDED",
}

export enum BookingCategory {
  OLD = 1,
  NEW = 2,
}

export const GenerateTreatmentName = (index: number) => {
  return `${String(index).padStart(2, '0')}`;
}

/**
 * FormatTreatmentLabel — unified label for a treatment entry.
 * Index is global across all modalities (01针灸, 02推拿, 03针灸...).
 * With name:    "01-treatment name"
 * Without name: "01 modality name"
 */
export const FormatTreatmentLabel = (
  index: number,
  modalityName: string,
  treatmentName?: string | null,
): string => {
  const num = String(index).padStart(2, '0');
  const name = treatmentName?.trim();
  return `${num} ${modalityName}${name ? ` - ${name}` : ""}`?.trim();
};

export const FormatReceiptFileName = (prescriptionId: number) => {
  return `RecordReceipt-#${prescriptionId}.docx`
}

export const FormatSicknessCertificateFileName = (firstName: string, lastName: string) => {
  return `SicknessCertificate-${firstName}_${lastName}.docx`
}
export enum PrescriptInternalPathKey {
  ACU_MAS_MODE,
  TREATMENT
}

export interface MasTechnique {
  point: any;
  method: any;
}

export enum TreatmentOptionCategory {
  OUTCOME = 1,
  RECOMMENDATION = 2
}